var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sfc-compare-checkbox",class:{'checked' : _vm.isAPlanToCompare(_vm.plan)},on:{"click":function($event){return _vm.$store.commit('updatePlansToCompare', _vm.plan)}}},[_c('span',{staticClass:"checkmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }